import { render, staticRenderFns } from "./talentService.vue?vue&type=template&id=17c87e89&scoped=true&"
import script from "./talentService.vue?vue&type=script&lang=js&"
export * from "./talentService.vue?vue&type=script&lang=js&"
import style0 from "./talentService.vue?vue&type=style&index=0&id=17c87e89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c87e89",
  null
  
)

export default component.exports